import * as React from 'react'
import { IDENTITY_ADMIN_GROUP, IDENTITY_CLIENT_GROUP } from "../const/Group";
import i18n from "../i18n";
import { IdentityLink } from '../interfaces/Identity';
import { SHIPMENT_STATE_RECEIVED, SHIPMENT_STATE_CANCELED, SHIPMENT_STATE_SENT, SHIPMENT_STATE_ASSIGNED, SHIPMENT_STATE_GENERATED, SHIPMENT_STATES } from '../const/Shipment';
import { ShipmentState } from '../interfaces/Shipment';
import { DeviceState } from '../interfaces/Device';
import { DEVICE_STATE_ACTIVE, DEVICE_STATE_UNAVAILABLE, DEVICE_STATE_UNASSIGNED } from '../const/Device';
import { MovementAdd } from '../components/devices/movement/Add';
import { NoticeStatus } from '../interfaces/Notice';
import { NOTICE_STATUS_PENDING, NOTICE_STATUS_SENT, NOTICE_STATUS_DISCARDED, NOTICE_STATUS_ERROR, NOTICE_STATUS_SENDING } from '../const/Notice';
import { MovementType } from '../interfaces/Movement';

const SERVICE_ID_LENGTH = 11;

function strip(string: string, char: String): string {
    while (string[0] === char) string = string.slice(1);
    while (string[string.length - 1] === char) string = string.slice(0, -1);
    return string;
}

Date.prototype.toString = function (): string {
    const day = this.getDate();
    const month = this.getMonth() + 1;
    const year = this.getFullYear();
    const hours = this.getHours();
    const mins = this.getMinutes();
    return i18n.t('date-format').replace('yyyy', year)
        .replace('mm', (month < 10 ? '0' : '') + month)
        .replace('dd', (day < 10 ? '0' : '') + day)
        .replace('hh', (hours < 10 ? '0' : '') + hours)
        .replace('MM', (mins < 10 ? '0' : '') + mins)
        .replace('yyyy', year);
}

export function getTimestamp() {
    const date = new Date();
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const hours = date.getHours()
    const mins = date.getMinutes()
    const sec = date.getSeconds()
    return (day < 10 ? '0' : '') + day + '_' + (month < 10 ? '0' : '') + month + '_' + year + '_' + (hours < 10 ? '0' : '') + hours + '_' + (mins < 10 ? '0' : '') + mins + '_' + (sec < 10 ? '0' : '') + sec;
}

export function serviceUserId(userId: string, group: string): string {
    switch (group) {
        case IDENTITY_ADMIN_GROUP:
        case IDENTITY_CLIENT_GROUP:
            return cleanIdentity(userId)
        default:
            return userId;
    }
}

function cleanRUT(userId: string): string {
    while (userId[0] === '0') userId = userId.slice(1);
    userId = strip(userId, ' ');
    userId = userId.replace(/[^0-9kK]+/g, "");
    return userId.toUpperCase();
}

function cleanIdentity(userId: string): string {
    if (userId.includes('A') || userId.includes('a')) return userId;
    const cleaned = cleanRUT(userId);
    return '0'.repeat(SERVICE_ID_LENGTH - cleaned.length) + cleaned;
}

export function formatUserId(userId: string, group?: string): string {
    switch (group) {
        case IDENTITY_ADMIN_GROUP:
        case IDENTITY_CLIENT_GROUP:
            return formatRUT(userId);
        default:
            return formatRUT(userId);
    }
}

function formatRUT(userId: string): string {
    if (userId.includes('_')) return strip(userId, ' ');
    if (userId.includes('A') || userId.includes('a')) return userId;

    userId = cleanRUT(userId);

    let formatUserId: string = "";
    if (userId.length < 2) {
        return userId;
    }
    formatUserId = "-" + userId.substring(userId.length - 1);
    let i: number;
    let cont: number = 0;
    for (i = userId.length - 2; i >= 0; i--) {
        formatUserId = userId.substring(i, i + 1) + formatUserId;
        cont++;
        if (cont == 3 && i != 0) {
            formatUserId = "." + formatUserId;
            cont = 0;
        }
    }
    return formatUserId.toUpperCase();
}

export function cleanProperty(text: string | null): string {
    if (text === null || text === undefined)
        return i18n.t('no-data');
    text = text.trim();
    return text;
}

export function capitalize(string: string): string {
    if (string.length === 0) return string;
    const parts = string.trim().replace(/\s+/g, ' ').split(' ');
    const parsed = parts.map(part => part[0].toUpperCase() + part.slice(1).toLowerCase());
    return parsed.join(' ');
}

export function checkRut(rut: string) {
    const valor: string[] = rut.replace(/\./g, '').split('-');
    const cuerpo = valor[0];
    const dv = valor[1].toUpperCase();

    // Si no cumple con el mínimo ej. (n.nnn.nnn)
    if (cuerpo.length < 5) { console.log("RUT Incompleto"); return false; }

    // Calcular Dígito Verificador
    let suma = 0;
    let multiplo = 2;

    // Para cada dígito del Cuerpo
    for (let i = 1; i <= cuerpo.length; i++) {
        // Obtener su Producto con el Múltiplo Correspondiente
        let index = multiplo * parseInt(cuerpo[cuerpo.length - i]);
        // Sumar al Contador General
        suma = suma + index;
        // Consolidar Múltiplo dentro del rango [2,7]
        if (multiplo < 7) { multiplo = multiplo + 1; } else { multiplo = 2; }

    }

    // Calcular Dígito Verificador en base al Módulo 11
    const dvEsperado = 11 - (suma % 11);
    // Casos Especiales (0 y K)
    const auxDv = dv === '0' ? 11 : dv === 'K' ? 10 : parseInt(dv);
    // Validar que el Cuerpo coincide con su Dígito Verificador
    if (dvEsperado !== auxDv) { console.log("RUT Inválido"); return false; }
    // Si todo sale bien, eliminar errores (decretar que es válido)
    console.log("RUT Válido"); return true;
}

export function activeFormatter(cell: any): JSX.Element {
    if (cell) return <i className="fa fa-check"></i>;
    return <i className="fa fa-remove"></i>;
}


export function linkFormatter(cell: IdentityLink): JSX.Element {
    return <a href={cell.path} className="btn btn-xs btn-primary">{cell.text}</a>;
}

export function checkDate(date: number): Date | string {
    return date ? new Date(date) : i18n.t('no-data')
}

export function translate(cell: any): string {
    return i18n.t(cell) || i18n.t('no-data');
}

export function idForReport(cell: any, row: any, enumObject: any, index: any) {
    return (<div>{index + 1}</div>)
}

export function officeFormatterForReport(cell: any, row: any): JSX.Element {
    return <span>{row.officeCode + ' - ' + row.officeName}</span>;
}

export function onlyDatePart(cell: any, row: any): JSX.Element {
    return <span>{row.date.split(',')[0]}</span>;
}

export function formatUserIdForList(cell: any, row: any): string {
    if (/\d/.test(row.userId)) {
        return formatRUT(row.userId)
    }
    return row.userId;
}

export function formatBranchOfficeForList(cell: any, row: any): string {
    let branch = row.branchOffice.code + ' - ' + row.branchOffice.name;
    if (row.branchOffice.code === 'CUID') return '';
    return branch;
}

export function formatRoleForList(cell: any, row: any): string {
    return row.role.roleName
}

export function formatNameForList(cell: any, row: any): string {
    return row.name
}

export function formatStatusForList(cell: any, row: any): JSX.Element {
    if (row.userActive) {
        return <span className="label label-success">{i18n.t('active')}</span>;
    }
    return <span className="label label-danger">{i18n.t('inactive')}</span>
}

export function activeFormatterOpenedAtForReport(cell: any, row: any): JSX.Element {
    if (cell) {
        return (
            <div>
                <i className="fa fa-check"></i><br />
                <span>{row.openedAt}  ({row.openedBy})</span>
            </div>
        );
    }
    return <i className="fa fa-remove"></i>;
}

export function activeFormatterClosedAtForReport(cell: any, row: any): JSX.Element {
    if (cell) {
        return (
            <div>
                <i className="fa fa-check"></i><br />
                <span>{row.closedAt}  ({row.closedBy})</span>
            </div>
        );
    }
    return <i className="fa fa-remove"></i>;
}
export function activeFormatterPendingReport(cell: any): JSX.Element {
    if (!cell) {
        return (
            <div>
                <i className="fa fa-remove" style={{ color: 'green' }}></i><br />
            </div>
        );
    }
    return <i className="fa fa-check" style={{ color: 'red' }}></i>;
}

function hourAndMinuts(date: any) {
    var hours = date.getHours();
    var mins = date.getMinutes();

    return (hours > 10 ? hours : '0' + hours) + ' : ' + (mins > 10 ? mins : '0' + mins);
}

export function shipmentStateFormatter(shipmentState: ShipmentState): JSX.Element {
    return <span className={"label label-" + (shipmentState === SHIPMENT_STATE_RECEIVED ? "success" :
        shipmentState === SHIPMENT_STATE_CANCELED ? "danger" :
            shipmentState === SHIPMENT_STATE_SENT ? "warning" :
                shipmentState === SHIPMENT_STATE_ASSIGNED ? "primary" :
                    shipmentState === SHIPMENT_STATE_GENERATED ? "default" :
                        "info")}>
        {i18n.t(shipmentState)}
    </span>;
}

export function shipmentStateCodeFormatter(shipmentState: ShipmentState): JSX.Element {
    return <span className={"label label-" + (SHIPMENT_STATES[shipmentState] === SHIPMENT_STATE_RECEIVED ? "success" :
        SHIPMENT_STATES[shipmentState]  === SHIPMENT_STATE_CANCELED ? "danger" :
            SHIPMENT_STATES[shipmentState]  === SHIPMENT_STATE_SENT ? "warning" :
                SHIPMENT_STATES[shipmentState]  === SHIPMENT_STATE_ASSIGNED ? "primary" :
                    SHIPMENT_STATES[shipmentState]  === SHIPMENT_STATE_GENERATED ? "default" :
                        "info")}>
        {i18n.t(SHIPMENT_STATES[shipmentState])}
    </span>;
}

export function deviceStateFormatter(deviceState: DeviceState): JSX.Element {
    return <span className={"label label-" + (deviceState === DEVICE_STATE_ACTIVE ? "success" :
        [DEVICE_STATE_UNAVAILABLE, DEVICE_STATE_UNAVAILABLE].includes(deviceState) ? "danger" :
            deviceState === DEVICE_STATE_UNASSIGNED ? "warning" : "info")}>
        {i18n.t(deviceState)}
    </span>;
}

export function decodeBase64(base64: string): string {
    base64 = base64.replace(/\s/g, '');
    return atob(base64);
};

export function trimSerialNumberRange(devices: string[]): string {
    let base: string = devices.shift()!;
    let last: string = String(base);
    let serialNumber = Number(base);
    let range = "";

    devices.map((serie: string) => {
        const asLong = Number(serie);
        if (asLong > serialNumber + 1) {
            if (base === last)
                range = range + base + ', ';
            else
                range = range + base + '-' + last + ', ';
            base = serie;
        }
        last = serie;
        serialNumber = asLong;
    });

    if (base === last)
        range = range + base + ', ';
    else
        range = range + base + '-' + last + ', ';

    return range.substring(0, range.length - 2);
}

export function formatSerialNumberRange(serialNumbers: string[]): string {
    serialNumbers = serialNumbers.sort((prev: string, next: string) => Number(prev) < Number(next) ? -1 : 1);
    let base: string = serialNumbers.shift()!;
    let last: string = base;
    let serialNumber = Number(base);
    let range = "";

    serialNumbers.forEach((serie: string) => {
        const asLong = Number(serie);
        if (asLong > (serialNumber + 1)) {
            range = range + base + '-' + last + ',';
            base = serie;
        }
        last = serie;
        serialNumber = asLong;
        console.log(serie + ' ' + range);
    });
    range = range + base + '-' + last + ',';
    return range.substring(0, range.length - 1);
}

export function formatNoticeNameForList(cell: any, row: any): string {
    return row.noticeType.name
}

export function noticeStatusFormatter(noticeStatus: NoticeStatus): JSX.Element {
    return <span className={"label label-" + (noticeStatus === NOTICE_STATUS_SENT ? "success" :
        noticeStatus === NOTICE_STATUS_DISCARDED ? "danger" :
            noticeStatus === NOTICE_STATUS_ERROR ? "warning" :
                noticeStatus === NOTICE_STATUS_PENDING ? "primary" :
                    noticeStatus === NOTICE_STATUS_SENDING ? "default" :
                        "info")}>
        {i18n.t("notice-" + noticeStatus)}
    </span>;
}

export function stockManagementActionFormatter(cell: any, row: any): string { 
    return i18n.t("stock-management-type-" + row.actionTypeCode.toLowerCase());
}

export function dateFormatter(cell: any, row: any) {
    let date = cell != undefined && cell != "" ? new Date(cell) : "";
    return date.toString();
}

export function newDateFormatter(date: Date | string) {
    let aux = new Date(date);
    return aux.toString();
}

export function getFormattedDate() {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Los meses empiezan en 0
    const year = today.getFullYear();
    return `${day}${month}${year}`;
};